import React from 'react';
import './SubHeader.scss'
const SubHeader = (props) => {
    const { heading, headerButton, showText } = props;
    return (
        <header className="main_heading">
          <h1 id="heading-title">{heading}</h1>
          {showText}
          {headerButton}
        </header>
    )
}

export default SubHeader;